export const InvoiceReminderCommand = {
  export: 'export',
  openInvoice: 'openInvoice',
  previewReminder: 'previewReminder',
};
